<template>
  <div class="block__tabsSidebarRanking">
    <div class="select__wrapper mb-4">
      <font-awesome-icon :icon="['far', 'chevron-down']" />
      <b-form-select v-model="selected" :options="options" class="select">
      </b-form-select>
    </div>

    <div class="select__wrapper">
      <font-awesome-icon :icon="['far', 'chevron-down']" />
      <b-form-select v-model="selected" :options="options" class="select">
      </b-form-select>
    </div>



    <b-list-group>
      <div class="entete">
        <div class="title">{{title}}</div>
      </div>
      <b-list-group-item v-for="(list,index) in lists" :key="index">
          <b-button class="btn btn-listSearch">
            <PuSkeleton :loading="isLoading" :count="1" width='100%'>
              <div class="bt-list left">
                <div class="target" :class="putTheRightClass(list.target)">{{list.target}}</div>
                <span class="icon" :class="{active : activeIt(isObjectiv,list.objectiv)}">
                  <font-awesome-icon :icon="['fas', 'plane-departure']" />
                </span>
                <div class="ranking">
                  <!-- <PuSkeleton :loading="isLoading" :count="1" width='20px'> -->
                    {{index+1}}
                  <!-- </PuSkeleton> -->
                </div>
                <div class="fullname">{{list.fullname}}</div>
              </div>
              <div class="right">
                <span class="icon"  :class="{active :  activeIt(isTravel,list.travel)}">
                  <font-awesome-icon :icon="['fas', 'bullseye-arrow']" />
                </span>          
                {{list.result}}
              </div>
            </PuSkeleton>
          </b-button>
      </b-list-group-item>
    </b-list-group>






      <!-- <div class="item" v-for="(item, index) in itemData" :key="index">
        <PuSkeleton :count="2">
          {{ item.title }}
          {{ item.body }}
        </PuSkeleton>
      </div> -->




  </div>
</template>

<script>

import Utils from "../../Utils"
import { mapGetters } from 'vuex'
//
export default {
  name: "TabsSidebarRanking",
  components:{ 
  },
    computed: {
      ...mapGetters([
        'getGeneral',
        'getListsChallenge'
      ])
    },  
  props:{
  },
  data(){
    return { 
      isLoading:true,
      title:"Inspecteur régional",
      content:"",
      isTravel:false,
      isObjectiv:false,
      lists:10,
      // itemData: 10,
      selected:null,
      options: [
          { value: null, text: 'Please select an option' },
          { value: 'a', text: '1ère excursion - Taux AEL <div class="target green">En cours</div>' },
          { value: 'b', text: 'Selected Option' },
          { value: { C: '3PO' }, text: 'This is an option with object value' },
          { value: 'd', text: 'This one is disabled', disabled: true }
        ]      
    }
  },
  created (){
    this.content = this.getGeneral;
    this.lists =  this.getListsChallenge; 
    setTimeout(() => {
      this.isLoading = false;
      // this.majData();
    },2000);    
  },    
  methods : {
    putTheRightClass (target){
      return Utils.getTheClass(target);
    },
    activeIt(target,item){
      if(item == true){
        return target = !target;
      }
    }

  },  
  mounted (){
      // setTimeout(()=>{
      //   this.itemData = [
      //   {
      //     title: 'Item title',
      //     body: ' Make beautiful, animated loading skeletons thar automacilly adapt to your app.'
      //   },
      //   {
      //     title: 'Item title',
      //     body: ' Make beautiful, animated loading skeletons thar automacilly adapt to your app.'
      //   },
      //   {
      //     title: 'Item title',
      //     body: ' Make beautiful, animated loading skeletons thar automacilly adapt to your app.'
      //   },
      //   {
      //     title: 'Item title',
      //     body: ' Make beautiful, animated loading skeletons thar automacilly adapt to your app.'
      //   },

      //   ]
      // },3500)
  }
}
</script>